import api from '../api/axios';

export interface Account {
  id?: number;
  accountNumber: string;
  accountName: string;
  accountType: 'asset' | 'liability' | 'equity' | 'revenue' | 'expense';
  parentAccount?: number;
  balance?: number;
  currency?: string;
  description?: string;
  isActive?: boolean;
}

const AccountService = {
  getAll: (params?: any) => api.get('/accounts', { params }),
  getOne: (id: number, params?: any) => 
    api.get(`/accounts/${id}`, { 
      params: params || { populate: ['parentAccount', 'subAccounts'] } 
    }),
  create: (data: Account) => api.post('/accounts', { data }),
  update: (id: number, data: Partial<Account>) => 
    api.put(`/accounts/${id}`, { data }),
  delete: (id: number) => api.delete(`/accounts/${id}`),
  getByType: (type: string, params?: any) =>
    api.get('/accounts', {
      params: { ...params, 'filters[accountType][$eq]': type },
    }),
};

export default AccountService;

